import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { SupervisorService } from '../../../../../core/service/supervisor.service';
import { ISupervisor } from '../../../../model/supervisor.model';
import { ModalService } from '../../modal.service';
import {
  BaseSupervisorSearchListComponent
} from '../supervisor-search-and-list-modal/base-supervisor-search-and-list.component';
import {SharedPrimitivesModule} from '../../../../shared-primitives.module';
import {IconComponent} from '../../../../icon/icon.component';
import {SupervisorInfoCardComponent} from '../../../supervisor-info-card/supervisor-info-card.component';

@Component({
    selector: 'swap-supervisor-modal',
    templateUrl: './swap-supervisor-modal.component.html',
    styleUrls: ['./swap-supervisor-modal.component.scss'],
    standalone: true,
    imports: [
      SharedPrimitivesModule,
      IconComponent,
      SupervisorInfoCardComponent
    ]
})
export class SwapSupervisorModalComponent extends BaseSupervisorSearchListComponent implements OnInit {

  @Input()
  public currentSupervisorId!: string;

  public currentSupervisor!: ISupervisor;

  @Output() swapSupervisorEvent: EventEmitter<ISupervisor> = new EventEmitter<ISupervisor>();


  constructor(fb: UntypedFormBuilder,
              elementRef: ElementRef,
              private supervisorService: SupervisorService,
              private modalService: ModalService) { super(fb, elementRef); }

  override ngOnInit() {
    super.ngOnInit();
    this.selectSingleSupervisor = true;

    this.supervisorService.getSupervisor(this.currentSupervisorId).subscribe(supervisor => {
      this.currentSupervisor = supervisor;
    })
  }

  public save() {
    this.swapSupervisorEvent.emit(this.selectedSupervisors[0]);
    this.closeSupervisorAddModal();
  }

  private closeSupervisorAddModal(): void {
    this.modalService.close();
  }

  public dismissSwapSupervisorModal(): void {
    this.modalService.dismiss();
  }

  public canSwapSupervisor() {
    return !!this.selectedSupervisors[0] && this.selectedSupervisors[0].id !== this.currentSupervisor.id;
  }
}
